import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Container } from '@hivebrite/design-system/Container';
import { useBreakpoint } from '@hivebrite/design-system/Theme';

import Modal from 'hb-react/shared/components/DesignSystem/Modal';
import useFrameTheme from 'hb-react/shared/hooks/theme/useFrameTheme';
import ThemeProvider from 'hb-react/style/ThemeProvider';

const PreviewModal = ({
  children,
  isOpen,
  onCloseModal,
  screenReadersCloseButtonText,
  withFullScreenModal = true,
  overwritingStyles = {},
}) => {
  const breakpoint = useBreakpoint();
  const frameTheme = useFrameTheme();

  return (
    <Modal
      isOpen={isOpen}
      onCloseModal={onCloseModal}
      alignItems="center"
      screenReadersCloseButtonText={screenReadersCloseButtonText}
      withFullScreenModal={withFullScreenModal}
      isFocusOnRef={false}
      viewportProps={{ mt: { _: 'inherit', m: '5vh' } }}
      shouldUseDialog
      style={overwritingStyles}
    >
      {({ closeButton }) => (
        <ThemeProvider
          theme={frameTheme.themeName}
          fontBrightness={frameTheme.fontBrightness}
        >
          <ContainerStyled
            breakpoint={breakpoint}
            bg={frameTheme.backgroundColor}
          >
            {closeButton}
            {children}
          </ContainerStyled>
        </ThemeProvider>
      )}
    </Modal>
  );
};

PreviewModal.propTypes = {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onCloseModal: PropTypes.func,
  screenReadersCloseButtonText: PropTypes.string,
};

export default PreviewModal;

const ContainerStyled = styled(Container)
  .withConfig({
    shouldForwardProp: (prop) => !['breakpoint'].includes(prop),
  })
  .attrs({
    width: { _: '100%', l: '90vw', xl: '1376px' },
    height: { _: '100%', l: '90vh' },
    position: 'relative',
    p: { _: 4, m: 8, l: 0 },
  })`

  ${({ breakpoint }) =>
    (breakpoint === 's' || breakpoint === 'm') &&
    `
      display: flex;
      flex-direction: column;
      justify-content: start;
    `};
  `;
